import { gql } from '@apollo/client'

export const SEARCH_RETURN_CASES = gql`
  query searchReturnCases(
    $organisationID: ID!
    $searchterm: String
    $limit: Int
    $employeeID: ID
  ) {
    searchReturnCases(
      organisationID: $organisationID
      searchterm: $searchterm
      limit: $limit
      employeeID: $employeeID
    ) {
      totalCount
      returnCases {
        id
        organisationID
        portalStatus
        employee {
          id
          contact {
            firstName
            lastName
          }
        }
        stocklistItem {
          imei
          imei2
          serialNumber
          deviceDefinition {
            imageURL
            name
            productType
          }
        }
      }
    }
  }
`
